

export enum KalturaCuePointType {
    ad = 'adCuePoint.Ad',
	annotation = 'annotation.Annotation',
	code = 'codeCuePoint.Code',
	event = 'eventCuePoint.Event',
	quizAnswer = 'quiz.QUIZ_ANSWER',
	quizQuestion = 'quiz.QUIZ_QUESTION',
	thumb = 'thumbCuePoint.Thumb'
}